<script>
export default {
    name: "AppointmentsIndex",

    data() {

        return {
          appointments: [],
          consultants: [],
          departments: [],
          appntment: {
              id: 0,
              patientID: this.$route.params.patientID,
              visitNo: 0,
              encounterID: 0,
              doctorID: 0,
              doctor: ``,
              clinicID: 0,
              clinic: ``,
              appointmentDate: this.$moment().format(`YYYY-MM-DD`),
              time: this.$moment().format('HH:MM'),
              comment: ``,
              userName: this.$root.username,
              cancelled: false,
          },
          patient: {},
          filter: {
            doctor: 0,
            from: this.$moment().format(`YYYY-MM-DD`),
            to: this.$moment().format(`YYYY-MM-DD`),
            search: ``,
          },
        };
    },

    watch: {
      '$route.params.patientID'() {
        this.fetchPatient();
      },

      'appntment.doctorID'() {
        if(!this.appntment.doctorID) {
          this.appntment.doctor = ``;
          return;
        }

        this.consultants.forEach(cons => {
          if(cons.id == this.appntment.doctorID) {
            this.appntment.doctor = cons.names;
          }
        });
      },

      'appntment.clinicID'() {
        if(!this.appntment.clinicID) {
          this.appntment.clinic = ``;
          return;
        }

        this.departments.forEach(dep => {
          if(dep.clinicId == this.appntment.clinicID) {
            this.appntment.clinic = dep.clinic;
          }
        });
      },
    },

    mounted() {
      this.$root.loading = true;
      Promise.all([ 
          this.fetchConsultants(), this.fetchAppointments(), 
          this.fetchPatient(), this.fetchDepartments(),
        ]).then(() => {
          this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; })
    },

    methods: {

      fetchConsultants() {

        return this.$http.get(`Shared/GetActiveConsultants`).then(({ data }) => {
          this.consultants = data;
        }).catch(() => {});
      },

      fetchDepartments() {

          return this.$http.get(`MasterData/GetClinics`).then(({ data }) => {
              this.departments = data;
          }).catch(() => {});
      },

      fetchAppointments() {
        let url = `Appointments/GetPatientVisitReport`;
            url += `?DoctorId=${this.filter.doctor}`;
            url += `&Datefrom=${this.filter.from}`;
            url += `&Dateto=${this.filter.to}`;
            url += this.filter.search ? `&SearchText=${this.filter.search}` : ``;

        return this.$http.get(url).then(({ data }) => {
          this.appointments = data;
        }).catch(() => {});
      },

      fetchPatient() {
          if(!this.$route.params.patientID) return Promise.reject();

          let url = `PatientRegistration/GetSpecificPatient`;
              url += `?PatientID=${this.$route.params.patientID}`;

          return this.$http.get(url).then(({ data }) => {
              this.patient = data.length ? data[0] : {};
          }).catch(() => {});
      },

      printAppointments() {
        let url = `/appointments/print/all?from=${this.filter.from}`;
            url += `&to=${this.filter.to}&doctor=${this.filter.doctor}`;

          window.open(
          url,
          "_blank",
          `AppointmentsPrint`,
        );
      },
  
      printAppointmentDetails(id, patient) {
        let url = `/appointments/print/details?appointment=${id}`;
            url += `&patient=${patient}`;

          window.open(
          url,
          "_blank",
          `AppointmentDetailsPrint`,
        );
      },
    },
    components: {
      'appointment-form': () => import('./Form.vue')
    }
}
</script>
<template>
<tail-base-layout>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
          <h5 class="text-sm font-medium">Appointments</h5>
        </template>
        <template v-slot:card-body>
          <appointment-form 
            v-if="$route.params.patientID"
            :doctors="consultants" 
            :appointment="appntment"
            :patient="patient"
            :departments="departments"
            @refresh="() => {
              appntment = {
                  id: 0,
                  patientID: $route.params.patientID,
                  visitNo: 0,
                  clinicID: 0,
                  doctorID: 0,
                  encounterID: 0,
                  appointmentDate: $moment().format(`YYYY-MM-DD`),
                  time: $moment().format('HH:MM'),
                  comment: ``,
                  userName: $root.username,
                  cancelled: false,
              };
              fetchAppointments();
            }" 
          />
          <div class="w-full flex flex-wrap">
            <div class="md:w-1/5 w-1/2 p-1">
              <label for="grid-from" class="label-control">From:</label>
              <input type="date" 
                v-model.trim="filter.from"
                id="grid-from" class="input-control input-sm text-xs">
            </div>
            <div class="md:w-1/5 w-1/2 p-1">
              <label for="grid-to" class="label-control">To:</label>
              <input type="date" 
                v-model.trim="filter.to"
                id="grid-to" class="input-control input-sm text-xs">
            </div>
            <div class="md:w-1/5 w-1/2 p-1">
              <label for="" class="label-control">Doctor:</label>
              <v-select 
                v-model.trim="filter.doctor"
                :options="consultants"
                label="names"
                :reduce="consultant => consultant.id"
                class="text-xs bg-white" />
            </div>
            <div class="md:w-1/5 w-1/2 p-1">
              <label for="grid-search" class="label-control">Search:</label>
              <input type="text" id="grid-search" class="input-control input-sm text-xs">
            </div>
            <div class="md:w-1/5 w-1/2 p-1">
                <button 
                  @click.prevent="() => {
                    $root.loading = true;
                    fetchAppointments().then(() => {
                      $root.loading = false;
                    });
                  }"
                  class="btn-sm text-xs btn-primary rounded mr-6 mt-4">
                    <i class="fa fa-filter"></i>Filter</button>
                <button 
                  @click.prevent="printAppointments"
                  class="btn-sm text-xs btn-info rounded mt-4">
                    <i class="fa fa-print"></i> Print</button>
            </div>
            <div class="w-full overflow-auto">
              <table class="table table-hover text-xs border">
                <thead class="bg-blue-500 text-white">
                  <tr class="w-full flex">
                    <th class="p-tiny flex-1">Date</th>
                    <th class="p-tiny flex-1">Patient</th>
                    <th class="p-tiny flex-1">Contact</th>
                    <th class="p-tiny flex-1">Clinic</th>
                    <th class="p-tiny flex-1">Doctor</th>
                    <th class="p-tiny w-1/6">Comment</th>
                    <th class="p-tiny w-1/12">Action</th>
                  </tr>
                </thead>
                <tbody class="bg-gray-200 flex flex-col items-center overflow-auto" style="height:30rem;">
                  <tr class="flex w-full" v-for="appointment in appointments" :key="appointment.id">
                    <td class="p-tiny flex-1">{{ appointment.date | dateFormat }}</td>
                    <td class="p-tiny flex-1">
                      <h5 class="text-xs font-bold">{{ appointment.names }}</h5>
                      <h5 class="text-xs">MRN: {{ appointment.patientID }}</h5>
                      <h5 class="text-xs">
                        IP: {{ appointment.ipfileno }} OP: {{ appointment.opfileno }}</h5>
                      <h5 class="text-xs">
                        ID: {{ appointment.nationalid }}</h5>
                    </td>
                    <td class="p-tiny flex-1">
                      <h5 class="text-xs">Residence: {{ appointment.residence }}</h5>
                      <h5 class="text-xs font-bold">Cell No: {{ appointment.homE_PHONE }}</h5>
                    </td>
                    <td class="p-tiny flex-1">{{ appointment.clinic }}</td>
                    <td class="p-tiny flex-1">{{ appointment.doctor }}</td>
                    <td class="p-tiny w-1/6 break-words">{{ appointment.comment || `-` }}</td>
                    <td class="p-tiny w-1/12">
                      <button 
                        @click.prevent="() => {
                          appntment = { 
                            id: appointment.id,
                            patientID: appointment.patientID,
                            doctorID: appointment.doctorId,
                            doctor: appointment.doctor,
                            clinicID: appointment.cLinicID,
                            clinic: appointment.clinic,
                            comment: appointment.comment,
                            userName: $root.username,
                            cancelled: false,
                            visitNo: appointment.visit_No,
                            patientID: appointment.patientID,
                            appointmentDate: $moment(appointment.date).format(`YYYY-MM-DD`),
                            time: $moment().format('HH:MM'),
                          };
                          $router.push({ 
                            name: `appointments.create`, 
                            params: { patientID: appointment.patientID 
                          }}).catch(() => {});
                        }"
                        class="btn-sm btn-info text-xs rounded mr-1">
                        <i class="fa fa-edit"></i> Edit
                      </button>
                      <button 
                        @click.prevent="printAppointmentDetails(appointment.id, appointment.patientID)"
                        class="btn-sm btn-primary text-xs rounded">
                          <i class="fa fa-print"></i> Print</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
